(function($){
    $(document).on('ready.tooltip', function(){
    	if($.fn && $.fn.tooltip){
			$('[data-toggle="tooltip"]').tooltip();
		}
    });
})(jQuery);
